// extracted by mini-css-extract-plugin
export default {"gameState":"GameState_gameState__Nshn4","active":"GameState_active__pZ5a2","tempSuitValue":"GameState_tempSuitValue__jEYlF","label":"GameState_label__aCrWu"};